export default __webpack_public_path__ + "static/media/back-icon.a0d5f06f.svg";